import Vue from "vue";
import ResourceService from "./resource.service";

class HajjDawraOperationService extends ResourceService {
  static get resource() {
    return "hajj-dawra-operations";
  }

  static salesOrderApprovalCandidates(params = {}) {
    return this.get("sales-order/approval-candidates", params);
  }

  static salesOrderPrefill(data = {}) {
    return this.post(data, "sales-order/prefill");
  }

  static exportDawraOperations(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/export`, {
          responseType: "blob",
          params,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}

export default HajjDawraOperationService;
